import React, { useState, useEffect } from 'react';
import "./FileFormatEditscss.css";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
const configData = require( './../../config.json');

function JsonFilterComponent() {
    const [companies, setCompanies] = useState([]);
    const [fileTypes, setFileTypes] = useState([]);
    const [fileStructureNames, setFileStructureNames] = useState([]);
    const [company, setCompany] = useState('');
    const [fileType, setFileType] = useState('');
    const [fileStructureName, setFileStructureName] = useState('');
    const [fileFrequency, setFileFrequency] = useState('');
    const [mailId, setMailId] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [expenseFileData, setExpenseFileData] = useState({});
    const [isPopupCheckboxChecked, setIsPopupCheckboxChecked] = useState(false);
    const [SelectedFileStructureName, setSelectedFileStructureName] = useState('');
    const [uploadFrequencyData, setUploadFrequencyData] = useState({
        frequency: '',
        frequencyDetails: '',
        dateLastUploaded: '',
        emailInfo: ''
    });

    const frequencies = ["Daily", "Weekly", "Monthly", "Yearly", "Semiannually"];
    const types = ["text", "StandardDate", "Int", "MoneyFloat"];

    useEffect(() => {
        // Grab organizations the user has access to 
        fetch(configData.FILEVALIDATION_URL+'get_organizations')
            .then(response => response.json())
            .then(data => setCompanies(data));
    }, []);

    const handleFilter = () => {
        fetch(configData.FILEVALIDATION_URL+`filterdata?company=${company}&fileType=${fileType}&fileStructureName=${fileStructureName}&fileFrequency=${fileFrequency}&mailId=${mailId}`)
            .then(response => response.json())
            .then(
                // data => setFilteredData(data)
                data => {
                    // toast.error(JSON.stringify(data, null, 2));
                    setFilteredData(data)
                }
            );
    };

    const handleRowClick = (data) => {
        setSelectedData(data);
        fetch(configData.FILEVALIDATION_URL+`getlocalfileformatjson?company=${data.company}&fileType=${data.fileType}&fileStructureName=${data.fileStructureName}&fileFrequency=${data.fileFrequency}&mailId=${data.mailId}`)
            .then(response => response.json())
            .then(jsonData => {
                setExpenseFileData(jsonData[data.fileStructureName] || {});

                fetch(configData.FILEVALIDATION_URL+`getalluploadfrequency?company=${data.company}&fileType=${data.fileType}&FileStructureName=${data.fileStructureName}`)
                    .then(response => response.json())
                    .then(frequencyData => {
                        setUploadFrequencyData({
                            frequency: frequencyData.FrequencyType || '',
                            frequencyDetails: frequencyData.FrequencyDetails || '',
                            dateLastUploaded: frequencyData.DateLastUploaded || '',
                            emailInfo: frequencyData.EmailInfo || ''
                        });
                        setDialogOpen(true);
                    });
            });
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleFieldChange = (index, field, value) => {
        setExpenseFileData(prevData => ({
            ...prevData,
            [index]: {
                ...prevData[index],
                [field]: value
            }
        }));
    };

    const handleFrequencyChange = (field, value) => {
        setUploadFrequencyData(prevData => {
            if (field === 'frequency') {
                return {
                    ...prevData,
                    [field]: value,
                    frequencyDetails: ''
                };
            }
            return {
                ...prevData,
                [field]: value
            };
        });
    };

    const renderFrequencyInput = () => {
        switch (uploadFrequencyData.frequency) {
            case 'Weekly':
                return (
                    <div className="form-group mb-2">
                        <label>Select Days of the Week:</label>
                        <select
                            multiple
                            value={uploadFrequencyData.frequencyDetails.split(':')}
                            onChange={(e) =>
                                handleFrequencyChange(
                                    'frequencyDetails',
                                    Array.from(e.target.selectedOptions, option => option.value).join(':')
                                )
                            }
                        >
                            <option value="Sunday">Sunday</option>
                            <option value="Monday">Monday</option>
                            <option value="Tuesday">Tuesday</option>
                            <option value="Wednesday">Wednesday</option>
                            <option value="Thursday">Thursday</option>
                            <option value="Friday">Friday</option>
                            <option value="Saturday">Saturday</option>
                        </select>
                    </div>
                );
            default:
                return null;
        }
    };

    const handleAddField = () => {
        const newIndex = Object.keys(expenseFileData).length;
        setExpenseFileData(prevData => ({
            ...prevData,
            [newIndex]: { Type: '', Title: '' }
        }));
    };

    const handleDeleteField = (index) => {
        setExpenseFileData(prevData => {
            const newData = { ...prevData };
            delete newData[index];
            return newData;
        });
    };

    const handleUpdate = () => {
        // Check for empty fields in expenseFileData and set defaults if needed
        const updatedExpenseFileData = Object.keys(expenseFileData).reduce((acc, key) => {
            const data = expenseFileData[key];
            acc[key] = {
                ...data,
                Type: data.Type || 'text', // Set a default type if empty
                Title: data.Title || 'Untitled' // Set a default title if empty
            };
            return acc;
        }, {});
    
        fetch(configData.FILEVALIDATION_URL+'updatejsondata', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                company: selectedData.company,
                fileType: selectedData.fileType,
                fileStructureName: selectedData.fileStructureName,
                FileData: {
                    ...updatedExpenseFileData,
                    UploadFrequency: {
                        FrequencyType: uploadFrequencyData.frequency,
                        FrequencyDetails: uploadFrequencyData.frequencyDetails,
                        DateLastUploaded: uploadFrequencyData.dateLastUploaded,
                        EmailInfo: uploadFrequencyData.emailInfo
                    }
                }
            }),
        }).then(() => {
            setDialogOpen(false);
            handleFilter(); // Refresh the table data
        });
    };

    const fetchFileTypes = async (organization) => {
        try {
            
            const response = await axios.get(configData.FILEVALIDATION_URL+'filetypes', {
                params: {Organization: organization }
            })
           
            // const response = await fetch(configData.SERVER_URL + 'fincorp_getFileTypes');
            
            // toast.error('retreived: ' + response.data);
            setFileTypes(response.data);
            
        } catch (e) {
            toast.error('Error fetching file types:'+ e);
            // toast.error('Failed to fetch file types.');
        }
    };

    const handleChange = (e, index) => {
        const {name, value} = e.target;
        if (name === 'organization') {
            if(!value){
                setFileType("");
            }else{
                fetchFileTypes(value);
            }
            setCompany(value);
            
        } 
    };

    return (
        <div className="container-fileedit">
            <h2 className="title">Search File Structure</h2>
            <div className="grid">
                <div className="grid-item">
                    <label>Select Company:</label>
                    <select name= "organization" value={company} onChange={handleChange} >
                        <option value="">Select Company</option>
                        {companies.map(company => (
                            <option key={company[1]} value={company[1]}>{company[0]}</option>
                        ))}
                    </select>
                </div>
                <div className="grid-item">
                    <label>Select File Type:</label>
                    <select value={fileType} onChange={e => setFileType(e.target.value)} 
                    disabled={!company}>
                        <option value="">Select File Type</option>
                        {fileTypes.map(type => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                </div>
                <div className="grid-item">
                    <label>File Structure Name:</label>
                    <input
                        type="text"
                        list="fileStructureNames"
                        value={fileStructureName}
                        onChange={e => setFileStructureName(e.target.value)}
                        disabled={!company}
                    />
                    <datalist id="fileStructureNames">
                        {fileStructureNames.map(name => (
                            <option key={name} value={name}>{name}</option>
                        ))}
                    </datalist>
                </div>
                <div className="grid-item">
                    <label>Select Frequency Type:</label>
                    <select value={fileFrequency} onChange={e => setFileFrequency(e.target.value)}
                    disabled={!company}>
                        <option value="">Select Frequency Type</option>
                        {frequencies.map(freq => (
                            <option key={freq} value={freq}>{freq}</option>
                        ))}
                    </select>
                </div>
                <div className="grid-item">
                    <label>Mail ID:</label>
                    <input
                        type="email"
                        value={mailId}
                        onChange={e => setMailId(e.target.value)}
                        disabled={!company}
                    />
                </div>
                <div className="grid-item">
                    <button className="btn" onClick={handleFilter}>Filter</button>
                </div>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th>Company ID </th>
                        <th>File Type</th>
                        <th>File Structure Name</th>
                        <th>File Frequency</th>
                        <th>Mail ID</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map((data, index) => (
                        <tr key={index} onClick={() => handleRowClick(data)} className="clickable-row">
                            <td>{data.company}</td>
                            <td>{data.fileType}</td>
                            <td>{data.fileStructureName}</td>
                            <td>{data.fileFrequency}</td>
                            <td className="table-cell-truncate">{data.mailId}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {dialogOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>File Structure Details: {selectedData.fileStructureName}</h3>
                        <div className="form">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Column Name</th>
                                        <th>Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(expenseFileData).map((index) => (
                                        <tr key={index}>
                                            <td>{parseInt(index) + 1}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    value={expenseFileData[index].Title}
                                                    onChange={e => handleFieldChange(index, 'Title', e.target.value)}
                                                    disabled={!isPopupCheckboxChecked}
                                                />
                                            </td>
                                            <td>
                                                <select
                                                    value={expenseFileData[index].Type}
                                                    onChange={e => handleFieldChange(index, 'Type', e.target.value)}
                                                    disabled={!isPopupCheckboxChecked}
                                                >
                                                    {types.map(type => (
                                                        <option key={type} value={type}>{type}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <button className="delete-btn" onClick={() => handleDeleteField(index)} disabled={!isPopupCheckboxChecked}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <button className="add-btn" onClick={handleAddField} disabled={!isPopupCheckboxChecked}>Add New Field</button>
                        </div>

                        <div className="form">
                            <h4>Upload Frequency</h4>
                            <div className="form-row">
                                <label>Frequency Type:</label>
                                <select
                                    value={uploadFrequencyData.frequency}
                                    onChange={(e) => handleFrequencyChange('frequency', e.target.value)}
                                    disabled={!isPopupCheckboxChecked}
                                >
                                    <option value="">Select Frequency</option>
                                    {frequencies.map(freq => (
                                        <option key={freq} value={freq}>{freq}</option>
                                    ))}
                                </select>
                            </div>
                            {renderFrequencyInput()}
                            <div className="form-row">
                                <label>Email Info:</label>
                                <input
                                    type="text"
                                    value={uploadFrequencyData.emailInfo}
                                    onChange={(e) => handleFrequencyChange('emailInfo', e.target.value)}
                                    disabled={!isPopupCheckboxChecked}
                                />
                            </div>
                        </div>

                        <div className="form">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={isPopupCheckboxChecked}
                                    onChange={(e) => setIsPopupCheckboxChecked(e.target.checked)}
                                />
                                Enable Edits
                            </label>
                        </div>

                        <div className="modal-actions">
                            <button className="btn" onClick={handleDialogClose}>Cancel</button>
                            <button className="btn" onClick={handleUpdate} disabled={!isPopupCheckboxChecked}>Update</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default JsonFilterComponent;
